import { Component } from '@angular/core';

@Component({
  selector: 'adminapp-summary-loading',
  templateUrl: './summary-loading.component.html',
  styleUrls: ['./summary-loading.component.scss']
})
export class SummaryLoadingComponent {

  constructor() { }
}
